import { Component, OnDestroy, OnInit } from '@angular/core';
import { DischargeService } from 'src/app/services/discharge.service';
import { TankService } from 'src/app/services/tank.service';
import { Discharge } from 'src/app/shared/models/Discharge';
import { Tank } from 'src/app/shared/models/Tank';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/shared/models/User';
import * as XLSX from 'xlsx';
import { BehaviorSubject, Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { PaginationModule,PaginationConfig } from 'ngx-bootstrap/pagination';



@Component({
  selector: 'app-list-discharge-page',
  templateUrl: './list-discharge-page.component.html',
  styleUrls: ['./list-discharge-page.component.css']
})
export class ListDischargePageComponent implements OnInit, OnDestroy {
  fuel_names;
  isFilterVisible = false;
  discharges: Discharge[] = [];
  originalDischarges: Discharge[] = [];
  currentTank: Tank;
  filter = null;
  page = 1;
  itemsPerPage = 10;
  maxSizePage =  10;
  totalItems: number;
  totalAmount: number;
  currentUser: User;
  lowFilterWarning: string | null = null;
  lowFuelWarning: string | null = null;
  private refreshSubscription: Subscription;
  private dischargeListUpdated$ = new BehaviorSubject<void>(null);
  constructor(private dischargeService: DischargeService, private tankService: TankService, private userService: UserService) {

  }

  ngOnInit() {

    this.tankService.getCurrentTank().subscribe((tank) => {
      this.currentTank = tank;
      // Después de obtener el tanque, obtenemos la lista de cargos.
      this.listDischarges();
      this.startAutoRefresh();
      // console.log(this)
    });

    this.currentUser = this.userService.getCurrentUser();

    this.tankService.getLowFilterWarningsByUser(this.currentUser).subscribe((warning) => {
      this.lowFilterWarning = warning;
    });

    this.tankService.getLowFuelWarningByUser(this.currentUser).subscribe((warning) => {
      if (warning) {
        this.lowFuelWarning = warning;
      }
    });

  }

  pageChanged(event: PageChangedEvent): void {
    // const startItem = (event.page - 1) * event.itemsPerPage;
    // const endItem = event.page * event.itemsPerPage;
    // this.discharges = this.contentArray.slice(startItem, endItem);
    this.page = event.page;
 }

  ngOnDestroy() {
    this.stopAutoRefresh();
  }

  private startAutoRefresh() {
    this.refreshSubscription = interval(2000) // Actualiza cada 2 segundos
      .pipe(
        switchMap(() => this.dischargeService.getDischargeByTankWithPagination(this.currentTank.id,this.page))
      )
      .subscribe((data) => {
        this.discharges = data.discharges;
        this.totalItems = data.totalItems;
        this.fuel_names = data.fuel_name_filter;
      });
  }

  private stopAutoRefresh() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  listDischarges() {
    this.stopAutoRefresh();
    this.dischargeService.getDischargeByTankWithPagination(this.currentTank.id,this.page).subscribe(data => {
      //console.log(data);
      this.discharges = data.discharges;
      this.originalDischarges = data.discharges;
      //debugger
      this.totalAmount = this.discharges.reduce((total, discharge) => total + discharge.amount, 0);
      this.dischargeListUpdated$.next(null);
      this.totalItems = data.totalItems;
      this.fuel_names = data.fuel_name_filter;
      // console.log(data.fuel_name_filter,    this.fuel_names)


    }, error => {
      console.log(error);
    })
  }

  deleteDischarge(id: any) {
    if (this.dischargeService.deleteDischarge(id).subscribe(data => {
      this.listDischarges();
    }, error => {
      console.log(error);
    })) {
      return;
    }
  }

  toggleFilterVisibility() {
    this.isFilterVisible = !this.isFilterVisible;
  }

  applyFilter(filter: any) {
    this.stopAutoRefresh();
    this.filter = filter;
    //console.log("filtros: ", filter);

    // Restaura la lista original antes de aplicar el filtro
    this.discharges = [...this.originalDischarges];

    this.dischargeService.getDischargeByTank(this.currentTank.id).subscribe(data => {

    this.itemsPerPage = data.length;
    this.maxSizePage = data.length;

      this.discharges = data.filter((discharge) => {
        // Inicialmente, todos los discharge pasan la prueba
        let passed = true;

        if (this.filter.vehicle && this.filter.vehicle !== discharge.vehicle) {
           passed = false;
        }

        if (this.filter.user && discharge.person !== this.filter.user) {
          passed = false;
        }

        if (this.filter.fuel_name && discharge.fuel_name !== this.filter.fuel_name) {
          passed = false;
        }

        if (this.filter.status) {
          const filterStatus = (this.filter.status === "EXITO") ? 0 : 1;
          if (filterStatus !== discharge.status) {
            passed = false;
          }
        }

        if (this.filter.dateFrom) {
          const voucherInitDate = new Date(discharge.date);
          if (voucherInitDate < this.filter.dateFrom) {
            passed = false;
          }
        }
        if (this.filter.dateTo) {
          const voucherDateTo = new Date(discharge.date);
          if (voucherDateTo > this.filter.dateTo) {
            passed = false;
          }
        }

        if (this.filter.businessName) {
          if (!discharge.vehicle_id || !discharge.vehicle_id.razon_social || discharge.vehicle_id.razon_social !== this.filter.businessName) {
            passed = false;
          }
        }



        return passed;
      });
      this.totalAmount = this.discharges.reduce((total, discharge) => total + discharge.amount, 0);


    }, error => {
      console.log(error);
    })


    //console.log("listado de descargas: ", this.discharges);
  }

  // Función para formatear la fecha para Cupon ID
  private formatDate(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}${minutes}${seconds}`;
  }


  exportToExcel() {
    // Crear una matriz de datos que se utilizará para crear la hoja de cálculo

    this.dischargeService.getDischargeByTank(this.currentTank.id).subscribe(data => {
      //console.log(data);

      const excelData = data.map(discharge => {

        const voucherDate = discharge.voucher_id && discharge.voucher_id.createdAt
        ? this.formatDate(new Date(discharge.voucher_id.createdAt))
        : 'N/A';

        return {
          'Ticket ID': discharge.id,
          Usuario: discharge.user_name,
          Vehiculo: discharge.vehicle_name,
          Conductor: discharge.vehicle_id && discharge.vehicle_id.driver ? discharge.vehicle_id.driver : 'A definir',
          'Razón Social/Vehículo ': discharge.vehicle_id && discharge.vehicle_id.razon_social ? discharge.vehicle_id.razon_social : 'A definir',
          'Kms/Hs': `${discharge.kilometers}`,
          Fecha: new Date(discharge.date).toLocaleString(),
          Combustible: discharge.fuel_name,
          Litros: discharge.amount.toFixed(2).replace('.', ','),
          Estado: discharge.status === 0 ? '✔' : '❌',
          'Razón Social/Usuario': discharge.razon_social,
          'Cupón ID': voucherDate,
          Cupon: discharge.voucher_description,
        };
      });

      // Crear un objeto de hoja de trabajo
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

      // Crear un objeto de libro de trabajo y agregar la hoja de trabajo a él
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Descargas');

      // Guardar el archivo Excel
      XLSX.writeFile(wb, 'descargas.xlsx');

    }, error => {
      console.log(error);
    })
  }

  exportFilteredToExcel() {
    // Usar las descargas filtradas actuales
    if (!this.filter) {
      alert('No hay filtros aplicados. Por favor, aplique filtros antes de exportar.');
      return;
    }

    const filteredDischarges = this.discharges;

    if (filteredDischarges.length === 0) {
      alert('No hay datos filtrados para exportar.');
      return;
    }

    // Crear una matriz de datos que se utilizará para crear la hoja de cálculo
    const excelData = filteredDischarges.map(discharge => {
      const voucherDate = discharge.voucher_id && discharge.voucher_id.createdAt
        ? this.formatDate(new Date(discharge.voucher_id.createdAt))
        : 'N/A';

      return {
        'Ticket ID': discharge.id,
        Usuario: discharge.user_name,
        Vehiculo: discharge.vehicle_name,
        Conductor: discharge.vehicle_id && discharge.vehicle_id.driver ? discharge.vehicle_id.driver : 'A definir',
        'Razón Social/Vehículo ': discharge.vehicle_id && discharge.vehicle_id.razon_social ? discharge.vehicle_id.razon_social : 'A definir',
        'Kms/Hs': `${discharge.kilometers}`,
        Fecha: new Date(discharge.date).toLocaleString(),
        Combustible: discharge.fuel_name,
        Litros: discharge.amount.toFixed(2).replace('.', ','),
        Estado: discharge.status === 0 ? '✔' : '❌',
        'Razón Social/Usuario': discharge.razon_social,
        'Cupón ID': voucherDate,
        Cupon: discharge.voucher_description,
      };
    });

    // Crear un objeto de hoja de trabajo
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // Crear un objeto de libro de trabajo y agregar la hoja de trabajo a él
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Descargas Filtradas');

    // Guardar el archivo Excel
    XLSX.writeFile(wb, 'descargas_filtradas.xlsx');
  }

  getDriver(discharge: any): string {
    if (discharge.driver_name && discharge.driver_name.trim() !== '') {
      return discharge.driver_name;
    }

    // Si no existe, mostrar el driver actual para no romper los anteriores
    if (discharge.vehicle_id && discharge.vehicle_id.driver && discharge.vehicle_id.driver.trim() !== '') {
      return discharge.vehicle_id.driver;
    }

    return 'A definir';
  }

}
